
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import Sidebar from 'components/Sidebar';
import SidebarGroup from 'components/Sidebar/SidebarGroup';
import SidebarGroupItem from 'components/Sidebar/SidebarGroup/SidebarGroupItem';
import { getForumThreadsOnSidebar } from 'selectors';
import queries from 'forumQueries';

class ForumThreadProfileSidebar extends Component {

  renderForumThreads(forumThreads) {
    return forumThreads.map(forumThread => {
      return (
        <SidebarGroupItem
          key={forumThread.id}
          title={forumThread.title}
          authorName={forumThread.author.userName}
          authorAvatarUrl={forumThread.author.avatar.url}
          articleUrl={`/forum/threads/${forumThread.id}`}
        />
      );
    });
  }

  renderForumThreadsGroups(forumThreadsGroups) {
    return forumThreadsGroups.map(forumThreadGroup => {
      const { forumThreads } = forumThreadGroup;

      return (
        <SidebarGroup key={forumThreadGroup.title} title={forumThreadGroup.title}>
          {this.renderForumThreads(forumThreads)}
        </SidebarGroup>
      );
    });
  }

  render() {
    return (
      <Sidebar>
        {this.renderForumThreadsGroups(this.props.forumThreadsGroups)}
      </Sidebar>
    );
  }
}

ForumThreadProfileSidebar.propTypes = {
  forumThreadsGroups: PropTypes.array
};

const mapStateToProps = state => {
  const forumThreadsGroups = [];
  const queryString = JSON.stringify(queries['Popular']);
  const allForumThreads = getForumThreadsOnSidebar(state, { page: 1, queryString });
  const forumThreads = allForumThreads.slice(0, Math.min(3, allForumThreads.length));

  if(forumThreads.length > 0) {
    forumThreadsGroups.push({
      title: __('members.forum.titles.popular'),
      forumThreads
    });
  }

	return {
    forumThreadsGroups
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForumThreadProfileSidebar);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Forum/ForumThreadProfile/ForumThreadProfileSidebar/index.js
 **/